import React from 'react'
import { ComparisonIconBeam } from '@intelie/ui'
import { useTheme } from 'styled-components'
import { ConditionalOperationIcon } from 'plugin-alerts-dashboard-channels/channelAlerts/constants/operations'
import Icon from 'plugin-alerts-dashboard-channels/common/styles/Icon.style'

const EMPTY_FOR_AT_LEAST = 0

type Props = {
    operation: [ConditionalOperationIcon, string]
    value: number
    uom: string
    channelName: string
    leastAt: number
    leastAtUom: string
    criticality: string
    color: string
}

export const TriggerConditionExpression = (props: Props): JSX.Element => {
    const theme = useTheme().themeName as Theme

    return (
        <>
            If <strong>{props.channelName}</strong>
            {/* //TODO Add limit to icon beam */}
            <ComparisonIconBeam comparison={props.operation[0]} theme={theme} />({props.operation[1]})
            <strong>
                {props.value} {props.uom}
            </strong>
            for at least <strong>{props.leastAt || EMPTY_FOR_AT_LEAST}</strong>
            {props.leastAtUom}, then
            <Icon className="fas fa-circle" size={10} color={props.color} />
            <strong>{props.criticality}</strong>
        </>
    )
}

export const TriggerConditionExpressionPT = (props: Props): JSX.Element => {
    const theme = useTheme().themeName as Theme

    return (
        <>
            Se <strong>{props.channelName}</strong>
            <ComparisonIconBeam comparison={props.operation[0]} theme={theme} /> ({props.operation[1]})
            <strong>
                {props.value} {props.uom}
            </strong>
            por pelo menos <strong>{props.leastAt || EMPTY_FOR_AT_LEAST}</strong>
            {props.leastAtUom}, então
            <Icon className="fas fa-circle" size={10} color={props.color} />
            <strong>{props.criticality}</strong>
        </>
    )
}
